module.exports = __webpack_public_path__ + "static/media/logo_square_white_background_with_padding.cddcda01.png";